
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("dBs8J", function(module, exports) {
"use strict";
function $9e748f0e7cb702a5$var$Vnode(tag, key, attrs, children, text, dom) {
    return {
        tag: tag,
        key: key,
        attrs: attrs,
        children: children,
        text: text,
        dom: dom,
        domSize: undefined,
        state: undefined,
        events: undefined,
        instance: undefined
    };
}
$9e748f0e7cb702a5$var$Vnode.normalize = function(node) {
    if (Array.isArray(node)) return $9e748f0e7cb702a5$var$Vnode("[", undefined, undefined, $9e748f0e7cb702a5$var$Vnode.normalizeChildren(node), undefined, undefined);
    if (node == null || typeof node === "boolean") return null;
    if (typeof node === "object") return node;
    return $9e748f0e7cb702a5$var$Vnode("#", undefined, undefined, String(node), undefined, undefined);
};
$9e748f0e7cb702a5$var$Vnode.normalizeChildren = function(input) {
    var children = [];
    if (input.length) {
        var isKeyed = input[0] != null && input[0].key != null;
        // Note: this is a *very* perf-sensitive check.
        // Fun fact: merging the loop like this is somehow faster than splitting
        // it, noticeably so.
        for(var i = 1; i < input.length; i++){
            if ((input[i] != null && input[i].key != null) !== isKeyed) throw new TypeError(isKeyed && (input[i] != null || typeof input[i] === "boolean") ? "In fragments, vnodes must either all have keys or none have keys. You may wish to consider using an explicit keyed empty fragment, m.fragment({key: ...}), instead of a hole." : "In fragments, vnodes must either all have keys or none have keys.");
        }
        for(var i = 0; i < input.length; i++)children[i] = $9e748f0e7cb702a5$var$Vnode.normalize(input[i]);
    }
    return children;
};
module.exports = $9e748f0e7cb702a5$var$Vnode;

});

parcelRegister("e2F9W", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");
module.exports = function(html) {
    if (html == null) html = "";
    return $dBs8J("<", undefined, undefined, html, undefined, undefined);
};

});

parcelRegister("7PZrX", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");

var $5sRXF = parcelRequire("5sRXF");
module.exports = function() {
    var vnode = $5sRXF.apply(0, arguments);
    vnode.tag = "[";
    vnode.children = $dBs8J.normalizeChildren(vnode.children);
    return vnode;
};

});
parcelRegister("5sRXF", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");
// Call via `hyperscriptVnode.apply(startOffset, arguments)`
//
// The reason I do it this way, forwarding the arguments and passing the start
// offset in `this`, is so I don't have to create a temporary array in a
// performance-critical path.
//
// In native ES6, I'd instead add a final `...args` parameter to the
// `hyperscript` and `fragment` factories and define this as
// `hyperscriptVnode(...args)`, since modern engines do optimize that away. But
// ES5 (what Mithril.js requires thanks to IE support) doesn't give me that luxury,
// and engines aren't nearly intelligent enough to do either of these:
//
// 1. Elide the allocation for `[].slice.call(arguments, 1)` when it's passed to
//    another function only to be indexed.
// 2. Elide an `arguments` allocation when it's passed to any function other
//    than `Function.prototype.apply` or `Reflect.apply`.
//
// In ES6, it'd probably look closer to this (I'd need to profile it, though):
// module.exports = function(attrs, ...children) {
//     if (attrs == null || typeof attrs === "object" && attrs.tag == null && !Array.isArray(attrs)) {
//         if (children.length === 1 && Array.isArray(children[0])) children = children[0]
//     } else {
//         children = children.length === 0 && Array.isArray(attrs) ? attrs : [attrs, ...children]
//         attrs = undefined
//     }
//
//     if (attrs == null) attrs = {}
//     return Vnode("", attrs.key, attrs, children)
// }
module.exports = function() {
    var attrs = arguments[this], start = this + 1, children;
    if (attrs == null) attrs = {};
    else if (typeof attrs !== "object" || attrs.tag != null || Array.isArray(attrs)) {
        attrs = {};
        start = this;
    }
    if (arguments.length === start + 1) {
        children = arguments[start];
        if (!Array.isArray(children)) children = [
            children
        ];
    } else {
        children = [];
        while(start < arguments.length)children.push(arguments[start++]);
    }
    return $dBs8J("", attrs.key, attrs, children);
};

});


parcelRegister("j25vk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6JDlc"))(typeof window !== "undefined" ? window : null);

});
parcelRegister("6JDlc", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");

var $7srYg = parcelRequire("7srYg");
var $4e757650419c4338$var$delayedRemoval = $7srYg.delayedRemoval;
var $4e757650419c4338$var$domFor = $7srYg.domFor;
module.exports = function() {
    var nameSpace = {
        svg: "http://www.w3.org/2000/svg",
        math: "http://www.w3.org/1998/Math/MathML"
    };
    var currentRedraw;
    var currentRender;
    function getDocument(dom) {
        return dom.ownerDocument;
    }
    function getNameSpace(vnode) {
        return vnode.attrs && vnode.attrs.xmlns || nameSpace[vnode.tag];
    }
    //sanity check to discourage people from doing `vnode.state = ...`
    function checkState(vnode, original) {
        if (vnode.state !== original) throw new Error("'vnode.state' must not be modified.");
    }
    //Note: the hook is passed as the `this` argument to allow proxying the
    //arguments without requiring a full array allocation to do so. It also
    //takes advantage of the fact the current `vnode` is the first argument in
    //all lifecycle methods.
    function callHook(vnode) {
        var original = vnode.state;
        try {
            return this.apply(original, arguments);
        } finally{
            checkState(vnode, original);
        }
    }
    // IE11 (at least) throws an UnspecifiedError when accessing document.activeElement when
    // inside an iframe. Catch and swallow this error, and heavy-handidly return null.
    function activeElement(dom) {
        try {
            return getDocument(dom).activeElement;
        } catch (e) {
            return null;
        }
    }
    //create
    function createNodes(parent, vnodes, start, end, hooks, nextSibling, ns) {
        for(var i = start; i < end; i++){
            var vnode = vnodes[i];
            if (vnode != null) createNode(parent, vnode, hooks, ns, nextSibling);
        }
    }
    function createNode(parent, vnode, hooks, ns, nextSibling) {
        var tag = vnode.tag;
        if (typeof tag === "string") {
            vnode.state = {};
            if (vnode.attrs != null) initLifecycle(vnode.attrs, vnode, hooks);
            switch(tag){
                case "#":
                    createText(parent, vnode, nextSibling);
                    break;
                case "<":
                    createHTML(parent, vnode, ns, nextSibling);
                    break;
                case "[":
                    createFragment(parent, vnode, hooks, ns, nextSibling);
                    break;
                default:
                    createElement(parent, vnode, hooks, ns, nextSibling);
            }
        } else createComponent(parent, vnode, hooks, ns, nextSibling);
    }
    function createText(parent, vnode, nextSibling) {
        vnode.dom = getDocument(parent).createTextNode(vnode.children);
        insertDOM(parent, vnode.dom, nextSibling);
    }
    var possibleParents = {
        caption: "table",
        thead: "table",
        tbody: "table",
        tfoot: "table",
        tr: "tbody",
        th: "tr",
        td: "tr",
        colgroup: "table",
        col: "colgroup"
    };
    function createHTML(parent, vnode, ns, nextSibling) {
        var match = vnode.children.match(/^\s*?<(\w+)/im) || [];
        // not using the proper parent makes the child element(s) vanish.
        //     var div = document.createElement("div")
        //     div.innerHTML = "<td>i</td><td>j</td>"
        //     console.log(div.innerHTML)
        // --> "ij", no <td> in sight.
        var temp = getDocument(parent).createElement(possibleParents[match[1]] || "div");
        if (ns === "http://www.w3.org/2000/svg") {
            temp.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\">" + vnode.children + "</svg>";
            temp = temp.firstChild;
        } else temp.innerHTML = vnode.children;
        vnode.dom = temp.firstChild;
        vnode.domSize = temp.childNodes.length;
        // Capture nodes to remove, so we don't confuse them.
        var fragment = getDocument(parent).createDocumentFragment();
        var child;
        while(child = temp.firstChild)fragment.appendChild(child);
        insertDOM(parent, fragment, nextSibling);
    }
    function createFragment(parent, vnode, hooks, ns, nextSibling) {
        var fragment = getDocument(parent).createDocumentFragment();
        if (vnode.children != null) {
            var children = vnode.children;
            createNodes(fragment, children, 0, children.length, hooks, null, ns);
        }
        vnode.dom = fragment.firstChild;
        vnode.domSize = fragment.childNodes.length;
        insertDOM(parent, fragment, nextSibling);
    }
    function createElement(parent, vnode, hooks, ns, nextSibling) {
        var tag = vnode.tag;
        var attrs = vnode.attrs;
        var is = attrs && attrs.is;
        ns = getNameSpace(vnode) || ns;
        var element = ns ? is ? getDocument(parent).createElementNS(ns, tag, {
            is: is
        }) : getDocument(parent).createElementNS(ns, tag) : is ? getDocument(parent).createElement(tag, {
            is: is
        }) : getDocument(parent).createElement(tag);
        vnode.dom = element;
        if (attrs != null) setAttrs(vnode, attrs, ns);
        insertDOM(parent, element, nextSibling);
        if (!maybeSetContentEditable(vnode)) {
            if (vnode.children != null) {
                var children = vnode.children;
                createNodes(element, children, 0, children.length, hooks, null, ns);
                if (vnode.tag === "select" && attrs != null) setLateSelectAttrs(vnode, attrs);
            }
        }
    }
    function initComponent(vnode, hooks) {
        var sentinel;
        if (typeof vnode.tag.view === "function") {
            vnode.state = Object.create(vnode.tag);
            sentinel = vnode.state.view;
            if (sentinel.$$reentrantLock$$ != null) return;
            sentinel.$$reentrantLock$$ = true;
        } else {
            vnode.state = void 0;
            sentinel = vnode.tag;
            if (sentinel.$$reentrantLock$$ != null) return;
            sentinel.$$reentrantLock$$ = true;
            vnode.state = vnode.tag.prototype != null && typeof vnode.tag.prototype.view === "function" ? new vnode.tag(vnode) : vnode.tag(vnode);
        }
        initLifecycle(vnode.state, vnode, hooks);
        if (vnode.attrs != null) initLifecycle(vnode.attrs, vnode, hooks);
        vnode.instance = $dBs8J.normalize(callHook.call(vnode.state.view, vnode));
        if (vnode.instance === vnode) throw Error("A view cannot return the vnode it received as argument");
        sentinel.$$reentrantLock$$ = null;
    }
    function createComponent(parent, vnode, hooks, ns, nextSibling) {
        initComponent(vnode, hooks);
        if (vnode.instance != null) {
            createNode(parent, vnode.instance, hooks, ns, nextSibling);
            vnode.dom = vnode.instance.dom;
            vnode.domSize = vnode.dom != null ? vnode.instance.domSize : 0;
        } else vnode.domSize = 0;
    }
    //update
    /**
	 * @param {Element|Fragment} parent - the parent element
	 * @param {Vnode[] | null} old - the list of vnodes of the last `render()` call for
	 *                               this part of the tree
	 * @param {Vnode[] | null} vnodes - as above, but for the current `render()` call.
	 * @param {Function[]} hooks - an accumulator of post-render hooks (oncreate/onupdate)
	 * @param {Element | null} nextSibling - the next DOM node if we're dealing with a
	 *                                       fragment that is not the last item in its
	 *                                       parent
	 * @param {'svg' | 'math' | String | null} ns) - the current XML namespace, if any
	 * @returns void
	 */ // This function diffs and patches lists of vnodes, both keyed and unkeyed.
    //
    // We will:
    //
    // 1. describe its general structure
    // 2. focus on the diff algorithm optimizations
    // 3. discuss DOM node operations.
    // ## Overview:
    //
    // The updateNodes() function:
    // - deals with trivial cases
    // - determines whether the lists are keyed or unkeyed based on the first non-null node
    //   of each list.
    // - diffs them and patches the DOM if needed (that's the brunt of the code)
    // - manages the leftovers: after diffing, are there:
    //   - old nodes left to remove?
    // 	 - new nodes to insert?
    // 	 deal with them!
    //
    // The lists are only iterated over once, with an exception for the nodes in `old` that
    // are visited in the fourth part of the diff and in the `removeNodes` loop.
    // ## Diffing
    //
    // Reading https://github.com/localvoid/ivi/blob/ddc09d06abaef45248e6133f7040d00d3c6be853/packages/ivi/src/vdom/implementation.ts#L617-L837
    // may be good for context on longest increasing subsequence-based logic for moving nodes.
    //
    // In order to diff keyed lists, one has to
    //
    // 1) match nodes in both lists, per key, and update them accordingly
    // 2) create the nodes present in the new list, but absent in the old one
    // 3) remove the nodes present in the old list, but absent in the new one
    // 4) figure out what nodes in 1) to move in order to minimize the DOM operations.
    //
    // To achieve 1) one can create a dictionary of keys => index (for the old list), then iterate
    // over the new list and for each new vnode, find the corresponding vnode in the old list using
    // the map.
    // 2) is achieved in the same step: if a new node has no corresponding entry in the map, it is new
    // and must be created.
    // For the removals, we actually remove the nodes that have been updated from the old list.
    // The nodes that remain in that list after 1) and 2) have been performed can be safely removed.
    // The fourth step is a bit more complex and relies on the longest increasing subsequence (LIS)
    // algorithm.
    //
    // the longest increasing subsequence is the list of nodes that can remain in place. Imagine going
    // from `1,2,3,4,5` to `4,5,1,2,3` where the numbers are not necessarily the keys, but the indices
    // corresponding to the keyed nodes in the old list (keyed nodes `e,d,c,b,a` => `b,a,e,d,c` would
    //  match the above lists, for example).
    //
    // In there are two increasing subsequences: `4,5` and `1,2,3`, the latter being the longest. We
    // can update those nodes without moving them, and only call `insertNode` on `4` and `5`.
    //
    // @localvoid adapted the algo to also support node deletions and insertions (the `lis` is actually
    // the longest increasing subsequence *of old nodes still present in the new list*).
    //
    // It is a general algorithm that is fireproof in all circumstances, but it requires the allocation
    // and the construction of a `key => oldIndex` map, and three arrays (one with `newIndex => oldIndex`,
    // the `LIS` and a temporary one to create the LIS).
    //
    // So we cheat where we can: if the tails of the lists are identical, they are guaranteed to be part of
    // the LIS and can be updated without moving them.
    //
    // If two nodes are swapped, they are guaranteed not to be part of the LIS, and must be moved (with
    // the exception of the last node if the list is fully reversed).
    //
    // ## Finding the next sibling.
    //
    // `updateNode()` and `createNode()` expect a nextSibling parameter to perform DOM operations.
    // When the list is being traversed top-down, at any index, the DOM nodes up to the previous
    // vnode reflect the content of the new list, whereas the rest of the DOM nodes reflect the old
    // list. The next sibling must be looked for in the old list using `getNextSibling(... oldStart + 1 ...)`.
    //
    // In the other scenarios (swaps, upwards traversal, map-based diff),
    // the new vnodes list is traversed upwards. The DOM nodes at the bottom of the list reflect the
    // bottom part of the new vnodes list, and we can use the `v.dom`  value of the previous node
    // as the next sibling (cached in the `nextSibling` variable).
    // ## DOM node moves
    //
    // In most scenarios `updateNode()` and `createNode()` perform the DOM operations. However,
    // this is not the case if the node moved (second and fourth part of the diff algo). We move
    // the old DOM nodes before updateNode runs because it enables us to use the cached `nextSibling`
    // variable rather than fetching it using `getNextSibling()`.
    function updateNodes(parent, old, vnodes, hooks, nextSibling, ns) {
        if (old === vnodes || old == null && vnodes == null) return;
        else if (old == null || old.length === 0) createNodes(parent, vnodes, 0, vnodes.length, hooks, nextSibling, ns);
        else if (vnodes == null || vnodes.length === 0) removeNodes(parent, old, 0, old.length);
        else {
            var isOldKeyed = old[0] != null && old[0].key != null;
            var isKeyed = vnodes[0] != null && vnodes[0].key != null;
            var start = 0, oldStart = 0;
            if (!isOldKeyed) while(oldStart < old.length && old[oldStart] == null)oldStart++;
            if (!isKeyed) while(start < vnodes.length && vnodes[start] == null)start++;
            if (isOldKeyed !== isKeyed) {
                removeNodes(parent, old, oldStart, old.length);
                createNodes(parent, vnodes, start, vnodes.length, hooks, nextSibling, ns);
            } else if (!isKeyed) {
                // Don't index past the end of either list (causes deopts).
                var commonLength = old.length < vnodes.length ? old.length : vnodes.length;
                // Rewind if necessary to the first non-null index on either side.
                // We could alternatively either explicitly create or remove nodes when `start !== oldStart`
                // but that would be optimizing for sparse lists which are more rare than dense ones.
                start = start < oldStart ? start : oldStart;
                for(; start < commonLength; start++){
                    o = old[start];
                    v = vnodes[start];
                    if (o === v || o == null && v == null) continue;
                    else if (o == null) createNode(parent, v, hooks, ns, getNextSibling(old, start + 1, nextSibling));
                    else if (v == null) removeNode(parent, o);
                    else updateNode(parent, o, v, hooks, getNextSibling(old, start + 1, nextSibling), ns);
                }
                if (old.length > commonLength) removeNodes(parent, old, start, old.length);
                if (vnodes.length > commonLength) createNodes(parent, vnodes, start, vnodes.length, hooks, nextSibling, ns);
            } else {
                // keyed diff
                var oldEnd = old.length - 1, end = vnodes.length - 1, map, o, v, oe, ve, topSibling;
                // bottom-up
                while(oldEnd >= oldStart && end >= start){
                    oe = old[oldEnd];
                    ve = vnodes[end];
                    if (oe.key !== ve.key) break;
                    if (oe !== ve) updateNode(parent, oe, ve, hooks, nextSibling, ns);
                    if (ve.dom != null) nextSibling = ve.dom;
                    oldEnd--, end--;
                }
                // top-down
                while(oldEnd >= oldStart && end >= start){
                    o = old[oldStart];
                    v = vnodes[start];
                    if (o.key !== v.key) break;
                    oldStart++, start++;
                    if (o !== v) updateNode(parent, o, v, hooks, getNextSibling(old, oldStart, nextSibling), ns);
                }
                // swaps and list reversals
                while(oldEnd >= oldStart && end >= start){
                    if (start === end) break;
                    if (o.key !== ve.key || oe.key !== v.key) break;
                    topSibling = getNextSibling(old, oldStart, nextSibling);
                    moveDOM(parent, oe, topSibling);
                    if (oe !== v) updateNode(parent, oe, v, hooks, topSibling, ns);
                    if (++start <= --end) moveDOM(parent, o, nextSibling);
                    if (o !== ve) updateNode(parent, o, ve, hooks, nextSibling, ns);
                    if (ve.dom != null) nextSibling = ve.dom;
                    oldStart++;
                    oldEnd--;
                    oe = old[oldEnd];
                    ve = vnodes[end];
                    o = old[oldStart];
                    v = vnodes[start];
                }
                // bottom up once again
                while(oldEnd >= oldStart && end >= start){
                    if (oe.key !== ve.key) break;
                    if (oe !== ve) updateNode(parent, oe, ve, hooks, nextSibling, ns);
                    if (ve.dom != null) nextSibling = ve.dom;
                    oldEnd--, end--;
                    oe = old[oldEnd];
                    ve = vnodes[end];
                }
                if (start > end) removeNodes(parent, old, oldStart, oldEnd + 1);
                else if (oldStart > oldEnd) createNodes(parent, vnodes, start, end + 1, hooks, nextSibling, ns);
                else {
                    // inspired by ivi https://github.com/ivijs/ivi/ by Boris Kaul
                    var originalNextSibling = nextSibling, vnodesLength = end - start + 1, oldIndices = new Array(vnodesLength), li = 0, i = 0, pos = 2147483647, matched = 0, map, lisIndices;
                    for(i = 0; i < vnodesLength; i++)oldIndices[i] = -1;
                    for(i = end; i >= start; i--){
                        if (map == null) map = getKeyMap(old, oldStart, oldEnd + 1);
                        ve = vnodes[i];
                        var oldIndex = map[ve.key];
                        if (oldIndex != null) {
                            pos = oldIndex < pos ? oldIndex : -1 // becomes -1 if nodes were re-ordered
                            ;
                            oldIndices[i - start] = oldIndex;
                            oe = old[oldIndex];
                            old[oldIndex] = null;
                            if (oe !== ve) updateNode(parent, oe, ve, hooks, nextSibling, ns);
                            if (ve.dom != null) nextSibling = ve.dom;
                            matched++;
                        }
                    }
                    nextSibling = originalNextSibling;
                    if (matched !== oldEnd - oldStart + 1) removeNodes(parent, old, oldStart, oldEnd + 1);
                    if (matched === 0) createNodes(parent, vnodes, start, end + 1, hooks, nextSibling, ns);
                    else {
                        if (pos === -1) {
                            // the indices of the indices of the items that are part of the
                            // longest increasing subsequence in the oldIndices list
                            lisIndices = makeLisIndices(oldIndices);
                            li = lisIndices.length - 1;
                            for(i = end; i >= start; i--){
                                v = vnodes[i];
                                if (oldIndices[i - start] === -1) createNode(parent, v, hooks, ns, nextSibling);
                                else if (lisIndices[li] === i - start) li--;
                                else moveDOM(parent, v, nextSibling);
                                if (v.dom != null) nextSibling = vnodes[i].dom;
                            }
                        } else for(i = end; i >= start; i--){
                            v = vnodes[i];
                            if (oldIndices[i - start] === -1) createNode(parent, v, hooks, ns, nextSibling);
                            if (v.dom != null) nextSibling = vnodes[i].dom;
                        }
                    }
                }
            }
        }
    }
    function updateNode(parent, old, vnode, hooks, nextSibling, ns) {
        var oldTag = old.tag, tag = vnode.tag;
        if (oldTag === tag) {
            vnode.state = old.state;
            vnode.events = old.events;
            if (shouldNotUpdate(vnode, old)) return;
            if (typeof oldTag === "string") {
                if (vnode.attrs != null) updateLifecycle(vnode.attrs, vnode, hooks);
                switch(oldTag){
                    case "#":
                        updateText(old, vnode);
                        break;
                    case "<":
                        updateHTML(parent, old, vnode, ns, nextSibling);
                        break;
                    case "[":
                        updateFragment(parent, old, vnode, hooks, nextSibling, ns);
                        break;
                    default:
                        updateElement(old, vnode, hooks, ns);
                }
            } else updateComponent(parent, old, vnode, hooks, nextSibling, ns);
        } else {
            removeNode(parent, old);
            createNode(parent, vnode, hooks, ns, nextSibling);
        }
    }
    function updateText(old, vnode) {
        if (old.children.toString() !== vnode.children.toString()) old.dom.nodeValue = vnode.children;
        vnode.dom = old.dom;
    }
    function updateHTML(parent, old, vnode, ns, nextSibling) {
        if (old.children !== vnode.children) {
            removeDOM(parent, old, undefined);
            createHTML(parent, vnode, ns, nextSibling);
        } else {
            vnode.dom = old.dom;
            vnode.domSize = old.domSize;
        }
    }
    function updateFragment(parent, old, vnode, hooks, nextSibling, ns) {
        updateNodes(parent, old.children, vnode.children, hooks, nextSibling, ns);
        var domSize = 0, children = vnode.children;
        vnode.dom = null;
        if (children != null) {
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child != null && child.dom != null) {
                    if (vnode.dom == null) vnode.dom = child.dom;
                    domSize += child.domSize || 1;
                }
            }
            if (domSize !== 1) vnode.domSize = domSize;
        }
    }
    function updateElement(old, vnode, hooks, ns) {
        var element = vnode.dom = old.dom;
        ns = getNameSpace(vnode) || ns;
        updateAttrs(vnode, old.attrs, vnode.attrs, ns);
        if (!maybeSetContentEditable(vnode)) updateNodes(element, old.children, vnode.children, hooks, null, ns);
    }
    function updateComponent(parent, old, vnode, hooks, nextSibling, ns) {
        vnode.instance = $dBs8J.normalize(callHook.call(vnode.state.view, vnode));
        if (vnode.instance === vnode) throw Error("A view cannot return the vnode it received as argument");
        updateLifecycle(vnode.state, vnode, hooks);
        if (vnode.attrs != null) updateLifecycle(vnode.attrs, vnode, hooks);
        if (vnode.instance != null) {
            if (old.instance == null) createNode(parent, vnode.instance, hooks, ns, nextSibling);
            else updateNode(parent, old.instance, vnode.instance, hooks, nextSibling, ns);
            vnode.dom = vnode.instance.dom;
            vnode.domSize = vnode.instance.domSize;
        } else if (old.instance != null) {
            removeNode(parent, old.instance);
            vnode.dom = undefined;
            vnode.domSize = 0;
        } else {
            vnode.dom = old.dom;
            vnode.domSize = old.domSize;
        }
    }
    function getKeyMap(vnodes, start, end) {
        var map = Object.create(null);
        for(; start < end; start++){
            var vnode = vnodes[start];
            if (vnode != null) {
                var key = vnode.key;
                if (key != null) map[key] = start;
            }
        }
        return map;
    }
    // Lifted from ivi https://github.com/ivijs/ivi/
    // takes a list of unique numbers (-1 is special and can
    // occur multiple times) and returns an array with the indices
    // of the items that are part of the longest increasing
    // subsequence
    var lisTemp = [];
    function makeLisIndices(a) {
        var result = [
            0
        ];
        var u = 0, v = 0, i = 0;
        var il = lisTemp.length = a.length;
        for(var i = 0; i < il; i++)lisTemp[i] = a[i];
        for(var i = 0; i < il; ++i){
            if (a[i] === -1) continue;
            var j = result[result.length - 1];
            if (a[j] < a[i]) {
                lisTemp[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v = result.length - 1;
            while(u < v){
                // Fast integer average without overflow.
                // eslint-disable-next-line no-bitwise
                var c = (u >>> 1) + (v >>> 1) + (u & v & 1);
                if (a[result[c]] < a[i]) u = c + 1;
                else v = c;
            }
            if (a[i] < a[result[u]]) {
                if (u > 0) lisTemp[i] = result[u - 1];
                result[u] = i;
            }
        }
        u = result.length;
        v = result[u - 1];
        while(u-- > 0){
            result[u] = v;
            v = lisTemp[v];
        }
        lisTemp.length = 0;
        return result;
    }
    function getNextSibling(vnodes, i, nextSibling) {
        for(; i < vnodes.length; i++){
            if (vnodes[i] != null && vnodes[i].dom != null) return vnodes[i].dom;
        }
        return nextSibling;
    }
    // This handles fragments with zombie children (removed from vdom, but persisted in DOM through onbeforeremove)
    function moveDOM(parent, vnode, nextSibling) {
        if (vnode.dom != null) {
            var target;
            if (vnode.domSize == null) // don't allocate for the common case
            target = vnode.dom;
            else {
                target = getDocument(parent).createDocumentFragment();
                for (var dom of $4e757650419c4338$var$domFor(vnode))target.appendChild(dom);
            }
            insertDOM(parent, target, nextSibling);
        }
    }
    function insertDOM(parent, dom, nextSibling) {
        if (nextSibling != null) parent.insertBefore(dom, nextSibling);
        else parent.appendChild(dom);
    }
    function maybeSetContentEditable(vnode) {
        if (vnode.attrs == null || vnode.attrs.contenteditable == null && // attribute
        vnode.attrs.contentEditable == null // property
        ) return false;
        var children = vnode.children;
        if (children != null && children.length === 1 && children[0].tag === "<") {
            var content = children[0].children;
            if (vnode.dom.innerHTML !== content) vnode.dom.innerHTML = content;
        } else if (children != null && children.length !== 0) throw new Error("Child node of a contenteditable must be trusted.");
        return true;
    }
    //remove
    function removeNodes(parent, vnodes, start, end) {
        for(var i = start; i < end; i++){
            var vnode = vnodes[i];
            if (vnode != null) removeNode(parent, vnode);
        }
    }
    function removeNode(parent, vnode) {
        var mask = 0;
        var original = vnode.state;
        var stateResult, attrsResult;
        if (typeof vnode.tag !== "string" && typeof vnode.state.onbeforeremove === "function") {
            var result = callHook.call(vnode.state.onbeforeremove, vnode);
            if (result != null && typeof result.then === "function") {
                mask = 1;
                stateResult = result;
            }
        }
        if (vnode.attrs && typeof vnode.attrs.onbeforeremove === "function") {
            var result = callHook.call(vnode.attrs.onbeforeremove, vnode);
            if (result != null && typeof result.then === "function") {
                // eslint-disable-next-line no-bitwise
                mask |= 2;
                attrsResult = result;
            }
        }
        checkState(vnode, original);
        var generation;
        // If we can, try to fast-path it and avoid all the overhead of awaiting
        if (!mask) {
            onremove(vnode);
            removeDOM(parent, vnode, generation);
        } else {
            generation = currentRender;
            for (var dom of $4e757650419c4338$var$domFor(vnode))$4e757650419c4338$var$delayedRemoval.set(dom, generation);
            if (stateResult != null) stateResult.finally(function() {
                // eslint-disable-next-line no-bitwise
                if (mask & 1) {
                    // eslint-disable-next-line no-bitwise
                    mask &= 2;
                    if (!mask) {
                        checkState(vnode, original);
                        onremove(vnode);
                        removeDOM(parent, vnode, generation);
                    }
                }
            });
            if (attrsResult != null) attrsResult.finally(function() {
                // eslint-disable-next-line no-bitwise
                if (mask & 2) {
                    // eslint-disable-next-line no-bitwise
                    mask &= 1;
                    if (!mask) {
                        checkState(vnode, original);
                        onremove(vnode);
                        removeDOM(parent, vnode, generation);
                    }
                }
            });
        }
    }
    function removeDOM(parent, vnode, generation) {
        if (vnode.dom == null) return;
        if (vnode.domSize == null) // don't allocate for the common case
        {
            if ($4e757650419c4338$var$delayedRemoval.get(vnode.dom) === generation) parent.removeChild(vnode.dom);
        } else for (var dom of $4e757650419c4338$var$domFor(vnode, {
            generation: generation
        }))parent.removeChild(dom);
    }
    function onremove(vnode) {
        if (typeof vnode.tag !== "string" && typeof vnode.state.onremove === "function") callHook.call(vnode.state.onremove, vnode);
        if (vnode.attrs && typeof vnode.attrs.onremove === "function") callHook.call(vnode.attrs.onremove, vnode);
        if (typeof vnode.tag !== "string") {
            if (vnode.instance != null) onremove(vnode.instance);
        } else {
            var children = vnode.children;
            if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child != null) onremove(child);
            }
        }
    }
    //attrs
    function setAttrs(vnode, attrs, ns) {
        for(var key in attrs)setAttr(vnode, key, null, attrs[key], ns);
    }
    function setAttr(vnode, key, old, value, ns) {
        if (key === "key" || key === "is" || value == null || isLifecycleMethod(key) || old === value && !isFormAttribute(vnode, key) && typeof value !== "object") return;
        if (key[0] === "o" && key[1] === "n") return updateEvent(vnode, key, value);
        if (key.slice(0, 6) === "xlink:") vnode.dom.setAttributeNS("http://www.w3.org/1999/xlink", key.slice(6), value);
        else if (key === "style") updateStyle(vnode.dom, old, value);
        else if (hasPropertyKey(vnode, key, ns)) {
            if (key === "value") {
                // Only do the coercion if we're actually going to check the value.
                /* eslint-disable no-implicit-coercion */ var isFileInput = vnode.tag === "input" && vnode.attrs.type === "file";
                //setting input[value] to same value by typing on focused element moves cursor to end in Chrome
                //setting input[type=file][value] to same value causes an error to be generated if it's non-empty
                if ((vnode.tag === "input" || vnode.tag === "textarea") && vnode.dom.value === "" + value && (isFileInput || vnode.dom === activeElement(vnode.dom))) return;
                //setting select[value] to same value while having select open blinks select dropdown in Chrome
                if (vnode.tag === "select" && old !== null && vnode.dom.value === "" + value) return;
                //setting option[value] to same value while having select open blinks select dropdown in Chrome
                if (vnode.tag === "option" && old !== null && vnode.dom.value === "" + value) return;
                //setting input[type=file][value] to different value is an error if it's non-empty
                // Not ideal, but it at least works around the most common source of uncaught exceptions for now.
                if (isFileInput && "" + value !== "") {
                    console.error("`value` is read-only on file inputs!");
                    return;
                }
            /* eslint-enable no-implicit-coercion */ }
            // If you assign an input type that is not supported by IE 11 with an assignment expression, an error will occur.
            if (vnode.tag === "input" && key === "type") vnode.dom.setAttribute(key, value);
            else vnode.dom[key] = value;
        } else if (typeof value === "boolean") {
            if (value) vnode.dom.setAttribute(key, "");
            else vnode.dom.removeAttribute(key);
        } else vnode.dom.setAttribute(key === "className" ? "class" : key, value);
    }
    function removeAttr(vnode, key, old, ns) {
        if (key === "key" || key === "is" || old == null || isLifecycleMethod(key)) return;
        if (key[0] === "o" && key[1] === "n") updateEvent(vnode, key, undefined);
        else if (key === "style") updateStyle(vnode.dom, old, null);
        else if (hasPropertyKey(vnode, key, ns) && key !== "className" && key !== "title" // creates "null" as title
         && !(key === "value" && (vnode.tag === "option" || vnode.tag === "select" && vnode.dom.selectedIndex === -1 && vnode.dom === activeElement(vnode.dom))) && !(vnode.tag === "input" && key === "type")) vnode.dom[key] = null;
        else {
            var nsLastIndex = key.indexOf(":");
            if (nsLastIndex !== -1) key = key.slice(nsLastIndex + 1);
            if (old !== false) vnode.dom.removeAttribute(key === "className" ? "class" : key);
        }
    }
    function setLateSelectAttrs(vnode, attrs) {
        if ("value" in attrs) {
            if (attrs.value === null) {
                if (vnode.dom.selectedIndex !== -1) vnode.dom.value = null;
            } else {
                var normalized = "" + attrs.value // eslint-disable-line no-implicit-coercion
                ;
                if (vnode.dom.value !== normalized || vnode.dom.selectedIndex === -1) vnode.dom.value = normalized;
            }
        }
        if ("selectedIndex" in attrs) setAttr(vnode, "selectedIndex", null, attrs.selectedIndex, undefined);
    }
    function updateAttrs(vnode, old, attrs, ns) {
        if (old && old === attrs) console.warn("Don't reuse attrs object, use new object for every redraw, this will throw in next major");
        if (attrs != null) for(var key in attrs)setAttr(vnode, key, old && old[key], attrs[key], ns);
        var val;
        if (old != null) {
            for(var key in old)if ((val = old[key]) != null && (attrs == null || attrs[key] == null)) removeAttr(vnode, key, val, ns);
        }
    }
    function isFormAttribute(vnode, attr) {
        return attr === "value" || attr === "checked" || attr === "selectedIndex" || attr === "selected" && vnode.dom === activeElement(vnode.dom) || vnode.tag === "option" && vnode.dom.parentNode === activeElement(vnode.dom);
    }
    function isLifecycleMethod(attr) {
        return attr === "oninit" || attr === "oncreate" || attr === "onupdate" || attr === "onremove" || attr === "onbeforeremove" || attr === "onbeforeupdate";
    }
    function hasPropertyKey(vnode, key, ns) {
        // Filter out namespaced keys
        return ns === undefined && // If it's a custom element, just keep it.
        (vnode.tag.indexOf("-") > -1 || vnode.attrs != null && vnode.attrs.is || // If it's a normal element, let's try to avoid a few browser bugs.
        key !== "href" && key !== "list" && key !== "form" && key !== "width" && key !== "height" // && key !== "type"
        ) && key in vnode.dom;
    }
    //style
    function updateStyle(element, old, style) {
        if (old === style) ;
        else if (style == null) // New style is missing, just clear it.
        element.style = "";
        else if (typeof style !== "object") // New style is a string, let engine deal with patching.
        element.style = style;
        else if (old == null || typeof old !== "object") {
            // `old` is missing or a string, `style` is an object.
            element.style.cssText = "";
            // Add new style properties
            for(var key in style){
                var value = style[key];
                if (value != null) {
                    if (key.includes("-")) element.style.setProperty(key, String(value));
                    else element.style[key] = String(value);
                }
            }
        } else {
            // Both old & new are (different) objects.
            // Update style properties that have changed
            for(var key in style){
                var value = style[key];
                if (value != null && (value = String(value)) !== String(old[key])) {
                    if (key.includes("-")) element.style.setProperty(key, value);
                    else element.style[key] = value;
                }
            }
            // Remove style properties that no longer exist
            for(var key in old)if (old[key] != null && style[key] == null) {
                if (key.includes("-")) element.style.removeProperty(key);
                else element.style[key] = "";
            }
        }
    }
    // Here's an explanation of how this works:
    // 1. The event names are always (by design) prefixed by `on`.
    // 2. The EventListener interface accepts either a function or an object
    //    with a `handleEvent` method.
    // 3. The object does not inherit from `Object.prototype`, to avoid
    //    any potential interference with that (e.g. setters).
    // 4. The event name is remapped to the handler before calling it.
    // 5. In function-based event handlers, `ev.target === this`. We replicate
    //    that below.
    // 6. In function-based event handlers, `return false` prevents the default
    //    action and stops event propagation. We replicate that below.
    function EventDict() {
        // Save this, so the current redraw is correctly tracked.
        this._ = currentRedraw;
    }
    EventDict.prototype = Object.create(null);
    EventDict.prototype.handleEvent = function(ev) {
        var handler = this["on" + ev.type];
        var result;
        if (typeof handler === "function") result = handler.call(ev.currentTarget, ev);
        else if (typeof handler.handleEvent === "function") handler.handleEvent(ev);
        if (this._ && ev.redraw !== false) (0, this._)();
        if (result === false) {
            ev.preventDefault();
            ev.stopPropagation();
        }
    };
    //event
    function updateEvent(vnode, key, value) {
        if (vnode.events != null) {
            vnode.events._ = currentRedraw;
            if (vnode.events[key] === value) return;
            if (value != null && (typeof value === "function" || typeof value === "object")) {
                if (vnode.events[key] == null) vnode.dom.addEventListener(key.slice(2), vnode.events, false);
                vnode.events[key] = value;
            } else {
                if (vnode.events[key] != null) vnode.dom.removeEventListener(key.slice(2), vnode.events, false);
                vnode.events[key] = undefined;
            }
        } else if (value != null && (typeof value === "function" || typeof value === "object")) {
            vnode.events = new EventDict();
            vnode.dom.addEventListener(key.slice(2), vnode.events, false);
            vnode.events[key] = value;
        }
    }
    //lifecycle
    function initLifecycle(source, vnode, hooks) {
        if (typeof source.oninit === "function") callHook.call(source.oninit, vnode);
        if (typeof source.oncreate === "function") hooks.push(callHook.bind(source.oncreate, vnode));
    }
    function updateLifecycle(source, vnode, hooks) {
        if (typeof source.onupdate === "function") hooks.push(callHook.bind(source.onupdate, vnode));
    }
    function shouldNotUpdate(vnode, old) {
        do {
            if (vnode.attrs != null && typeof vnode.attrs.onbeforeupdate === "function") {
                var force = callHook.call(vnode.attrs.onbeforeupdate, vnode, old);
                if (force !== undefined && !force) break;
            }
            if (typeof vnode.tag !== "string" && typeof vnode.state.onbeforeupdate === "function") {
                var force = callHook.call(vnode.state.onbeforeupdate, vnode, old);
                if (force !== undefined && !force) break;
            }
            return false;
        }while (false); // eslint-disable-line no-constant-condition
        vnode.dom = old.dom;
        vnode.domSize = old.domSize;
        vnode.instance = old.instance;
        // One would think having the actual latest attributes would be ideal,
        // but it doesn't let us properly diff based on our current internal
        // representation. We have to save not only the old DOM info, but also
        // the attributes used to create it, as we diff *that*, not against the
        // DOM directly (with a few exceptions in `setAttr`). And, of course, we
        // need to save the children and text as they are conceptually not
        // unlike special "attributes" internally.
        vnode.attrs = old.attrs;
        vnode.children = old.children;
        vnode.text = old.text;
        return true;
    }
    var currentDOM;
    return function(dom, vnodes, redraw) {
        if (!dom) throw new TypeError("DOM element being rendered to does not exist.");
        if (currentDOM != null && dom.contains(currentDOM)) throw new TypeError("Node is currently being rendered to and thus is locked.");
        var prevRedraw = currentRedraw;
        var prevDOM = currentDOM;
        var hooks = [];
        var active = activeElement(dom);
        var namespace = dom.namespaceURI;
        currentDOM = dom;
        currentRedraw = typeof redraw === "function" ? redraw : undefined;
        currentRender = {};
        try {
            // First time rendering into a node clears it out
            if (dom.vnodes == null) dom.textContent = "";
            vnodes = $dBs8J.normalizeChildren(Array.isArray(vnodes) ? vnodes : [
                vnodes
            ]);
            updateNodes(dom, dom.vnodes, vnodes, hooks, null, namespace === "http://www.w3.org/1999/xhtml" ? undefined : namespace);
            dom.vnodes = vnodes;
            // `document.activeElement` can return null: https://html.spec.whatwg.org/multipage/interaction.html#dom-document-activeelement
            if (active != null && activeElement(dom) !== active && typeof active.focus === "function") active.focus();
            for(var i = 0; i < hooks.length; i++)hooks[i]();
        } finally{
            currentRedraw = prevRedraw;
            currentDOM = prevDOM;
        }
    };
};

});
parcelRegister("7srYg", function(module, exports) {
"use strict";
var $56e0d85f567b4c28$var$delayedRemoval = new WeakMap;
function* $56e0d85f567b4c28$var$domFor(vnode, object = {}) {
    // To avoid unintended mangling of the internal bundler,
    // parameter destructuring is not used here.
    var dom = vnode.dom;
    var domSize = vnode.domSize;
    var generation = object.generation;
    if (dom != null) do {
        var nextSibling = dom.nextSibling;
        if ($56e0d85f567b4c28$var$delayedRemoval.get(dom) === generation) {
            yield dom;
            domSize--;
        }
        dom = nextSibling;
    }while (domSize);
}
module.exports = {
    delayedRemoval: $56e0d85f567b4c28$var$delayedRemoval,
    domFor: $56e0d85f567b4c28$var$domFor
};

});



parcelRegister("iZais", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");
module.exports = function(render, schedule, console) {
    var subscriptions = [];
    var pending = false;
    var offset = -1;
    function sync() {
        for(offset = 0; offset < subscriptions.length; offset += 2)try {
            render(subscriptions[offset], $dBs8J(subscriptions[offset + 1]), redraw);
        } catch (e) {
            console.error(e);
        }
        offset = -1;
    }
    function redraw() {
        if (!pending) {
            pending = true;
            schedule(function() {
                pending = false;
                sync();
            });
        }
    }
    redraw.sync = sync;
    function mount(root, component) {
        if (component != null && component.view == null && typeof component !== "function") throw new TypeError("m.mount expects a component, not a vnode.");
        var index = subscriptions.indexOf(root);
        if (index >= 0) {
            subscriptions.splice(index, 2);
            if (index <= offset) offset -= 2;
            render(root, []);
        }
        if (component != null) {
            subscriptions.push(root, component);
            render(root, $dBs8J(component), redraw);
        }
    }
    return {
        mount: mount,
        redraw: redraw
    };
};

});

parcelRegister("5y2KI", function(module, exports) {
"use strict";

var $cITMw = parcelRequire("cITMw");

var $9eOch = parcelRequire("9eOch");
module.exports = function($window, oncompletion) {
    function PromiseProxy(executor) {
        return new Promise(executor);
    }
    function makeRequest(url, args) {
        return new Promise(function(resolve, reject) {
            url = $cITMw(url, args.params);
            var method = args.method != null ? args.method.toUpperCase() : "GET";
            var body = args.body;
            var assumeJSON = (args.serialize == null || args.serialize === JSON.serialize) && !(body instanceof $window.FormData || body instanceof $window.URLSearchParams);
            var responseType = args.responseType || (typeof args.extract === "function" ? "" : "json");
            var xhr = new $window.XMLHttpRequest(), aborted = false, isTimeout = false;
            var original = xhr, replacedAbort;
            var abort = xhr.abort;
            xhr.abort = function() {
                aborted = true;
                abort.call(this);
            };
            xhr.open(method, url, args.async !== false, typeof args.user === "string" ? args.user : undefined, typeof args.password === "string" ? args.password : undefined);
            if (assumeJSON && body != null && !hasHeader(args, "content-type")) xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");
            if (typeof args.deserialize !== "function" && !hasHeader(args, "accept")) xhr.setRequestHeader("Accept", "application/json, text/*");
            if (args.withCredentials) xhr.withCredentials = args.withCredentials;
            if (args.timeout) xhr.timeout = args.timeout;
            xhr.responseType = responseType;
            for(var key in args.headers)if ($9eOch.call(args.headers, key)) xhr.setRequestHeader(key, args.headers[key]);
            xhr.onreadystatechange = function(ev) {
                // Don't throw errors on xhr.abort().
                if (aborted) return;
                if (ev.target.readyState === 4) try {
                    var success = ev.target.status >= 200 && ev.target.status < 300 || ev.target.status === 304 || /^file:\/\//i.test(url);
                    // When the response type isn't "" or "text",
                    // `xhr.responseText` is the wrong thing to use.
                    // Browsers do the right thing and throw here, and we
                    // should honor that and do the right thing by
                    // preferring `xhr.response` where possible/practical.
                    var response = ev.target.response, message;
                    if (responseType === "json") {
                        // For IE and Edge, which don't implement
                        // `responseType: "json"`.
                        if (!ev.target.responseType && typeof args.extract !== "function") // Handle no-content which will not parse.
                        try {
                            response = JSON.parse(ev.target.responseText);
                        } catch (e) {
                            response = null;
                        }
                    } else if (!responseType || responseType === "text") // Only use this default if it's text. If a parsed
                    // document is needed on old IE and friends (all
                    // unsupported), the user should use a custom
                    // `config` instead. They're already using this at
                    // their own risk.
                    {
                        if (response == null) response = ev.target.responseText;
                    }
                    if (typeof args.extract === "function") {
                        response = args.extract(ev.target, args);
                        success = true;
                    } else if (typeof args.deserialize === "function") response = args.deserialize(response);
                    if (success) {
                        if (typeof args.type === "function") {
                            if (Array.isArray(response)) for(var i = 0; i < response.length; i++)response[i] = new args.type(response[i]);
                            else response = new args.type(response);
                        }
                        resolve(response);
                    } else {
                        var completeErrorResponse = function() {
                            try {
                                message = ev.target.responseText;
                            } catch (e) {
                                message = response;
                            }
                            var error = new Error(message);
                            error.code = ev.target.status;
                            error.response = response;
                            reject(error);
                        };
                        if (xhr.status === 0) // Use setTimeout to push this code block onto the event queue
                        // This allows `xhr.ontimeout` to run in the case that there is a timeout
                        // Without this setTimeout, `xhr.ontimeout` doesn't have a chance to reject
                        // as `xhr.onreadystatechange` will run before it
                        setTimeout(function() {
                            if (isTimeout) return;
                            completeErrorResponse();
                        });
                        else completeErrorResponse();
                    }
                } catch (e) {
                    reject(e);
                }
            };
            xhr.ontimeout = function(ev) {
                isTimeout = true;
                var error = new Error("Request timed out");
                error.code = ev.target.status;
                reject(error);
            };
            if (typeof args.config === "function") {
                xhr = args.config(xhr, args, url) || xhr;
                // Propagate the `abort` to any replacement XHR as well.
                if (xhr !== original) {
                    replacedAbort = xhr.abort;
                    xhr.abort = function() {
                        aborted = true;
                        replacedAbort.call(this);
                    };
                }
            }
            if (body == null) xhr.send();
            else if (typeof args.serialize === "function") xhr.send(args.serialize(body));
            else if (body instanceof $window.FormData || body instanceof $window.URLSearchParams) xhr.send(body);
            else xhr.send(JSON.stringify(body));
        });
    }
    // In case the global Promise is some userland library's where they rely on
    // `foo instanceof this.constructor`, `this.constructor.resolve(value)`, or
    // similar. Let's *not* break them.
    PromiseProxy.prototype = Promise.prototype;
    PromiseProxy.__proto__ = Promise // eslint-disable-line no-proto
    ;
    function hasHeader(args, name) {
        for(var key in args.headers){
            if ($9eOch.call(args.headers, key) && key.toLowerCase() === name) return true;
        }
        return false;
    }
    return {
        request: function(url, args) {
            if (typeof url !== "string") {
                args = url;
                url = url.url;
            } else if (args == null) args = {};
            var promise = makeRequest(url, args);
            if (args.background === true) return promise;
            var count = 0;
            function complete() {
                if (--count === 0 && typeof oncompletion === "function") oncompletion();
            }
            return wrap(promise);
            function wrap(promise) {
                var then = promise.then;
                // Set the constructor, so engines know to not await or resolve
                // this as a native promise. At the time of writing, this is
                // only necessary for V8, but their behavior is the correct
                // behavior per spec. See this spec issue for more details:
                // https://github.com/tc39/ecma262/issues/1577. Also, see the
                // corresponding comment in `request/tests/test-request.js` for
                // a bit more background on the issue at hand.
                promise.constructor = PromiseProxy;
                promise.then = function() {
                    count++;
                    var next = then.apply(promise, arguments);
                    next.then(complete, function(e) {
                        complete();
                        if (count === 0) throw e;
                    });
                    return wrap(next);
                };
                return promise;
            }
        }
    };
};

});
parcelRegister("cITMw", function(module, exports) {
"use strict";

var $iRA82 = parcelRequire("iRA82");
// Returns `path` from `template` + `params`
module.exports = function(template, params) {
    if (/:([^\/\.-]+)(\.{3})?:/.test(template)) throw new SyntaxError("Template parameter names must be separated by either a '/', '-', or '.'.");
    if (params == null) return template;
    var queryIndex = template.indexOf("?");
    var hashIndex = template.indexOf("#");
    var queryEnd = hashIndex < 0 ? template.length : hashIndex;
    var pathEnd = queryIndex < 0 ? queryEnd : queryIndex;
    var path = template.slice(0, pathEnd);
    var query = {};
    Object.assign(query, params);
    var resolved = path.replace(/:([^\/\.-]+)(\.{3})?/g, function(m, key, variadic) {
        delete query[key];
        // If no such parameter exists, don't interpolate it.
        if (params[key] == null) return m;
        // Escape normal parameters, but not variadic ones.
        return variadic ? params[key] : encodeURIComponent(String(params[key]));
    });
    // In case the template substitution adds new query/hash parameters.
    var newQueryIndex = resolved.indexOf("?");
    var newHashIndex = resolved.indexOf("#");
    var newQueryEnd = newHashIndex < 0 ? resolved.length : newHashIndex;
    var newPathEnd = newQueryIndex < 0 ? newQueryEnd : newQueryIndex;
    var result = resolved.slice(0, newPathEnd);
    if (queryIndex >= 0) result += template.slice(queryIndex, queryEnd);
    if (newQueryIndex >= 0) result += (queryIndex < 0 ? "?" : "&") + resolved.slice(newQueryIndex, newQueryEnd);
    var querystring = $iRA82(query);
    if (querystring) result += (queryIndex < 0 && newQueryIndex < 0 ? "?" : "&") + querystring;
    if (hashIndex >= 0) result += template.slice(hashIndex);
    if (newHashIndex >= 0) result += (hashIndex < 0 ? "" : "&") + resolved.slice(newHashIndex);
    return result;
};

});
parcelRegister("iRA82", function(module, exports) {
"use strict";
module.exports = function(object) {
    if (Object.prototype.toString.call(object) !== "[object Object]") return "";
    var args = [];
    for(var key in object)destructure(key, object[key]);
    return args.join("&");
    function destructure(key, value) {
        if (Array.isArray(value)) for(var i = 0; i < value.length; i++)destructure(key + "[" + i + "]", value[i]);
        else if (Object.prototype.toString.call(value) === "[object Object]") for(var i in value)destructure(key + "[" + i + "]", value[i]);
        else args.push(encodeURIComponent(key) + (value != null && value !== "" ? "=" + encodeURIComponent(value) : ""));
    }
};

});


parcelRegister("9eOch", function(module, exports) {
// This exists so I'm only saving it once.
"use strict";
module.exports = ({}).hasOwnProperty;

});


parcelRegister("4Ppi2", function(module, exports) {
"use strict";

var $7EF0O = parcelRequire("7EF0O");

module.exports = (parcelRequire("eFHZ8"))(typeof window !== "undefined" ? window : null, $7EF0O);

});
parcelRegister("7EF0O", function(module, exports) {
"use strict";

var $j25vk = parcelRequire("j25vk");

module.exports = (parcelRequire("iZais"))($j25vk, typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : null, typeof console !== "undefined" ? console : null);

});

parcelRegister("eFHZ8", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");

var $iVcuU = parcelRequire("iVcuU");

var $cITMw = parcelRequire("cITMw");

var $7lWrV = parcelRequire("7lWrV");

var $8KlxE = parcelRequire("8KlxE");

var $e9o88 = parcelRequire("e9o88");
var $aae70388e69e8325$var$sentinel = {};
function $aae70388e69e8325$var$decodeURIComponentSave(component) {
    try {
        return decodeURIComponent(component);
    } catch (e) {
        return component;
    }
}
module.exports = function($window, mountRedraw) {
    var callAsync = $window == null ? null : typeof $window.setImmediate === "function" ? $window.setImmediate : $window.setTimeout;
    var p = Promise.resolve();
    var scheduled = false;
    // state === 0: init
    // state === 1: scheduled
    // state === 2: done
    var ready = false;
    var state = 0;
    var compiled, fallbackRoute;
    var currentResolver = $aae70388e69e8325$var$sentinel, component, attrs, currentPath, lastUpdate;
    var RouterRoot = {
        onbeforeupdate: function() {
            state = state ? 2 : 1;
            return !(!state || $aae70388e69e8325$var$sentinel === currentResolver);
        },
        onremove: function() {
            $window.removeEventListener("popstate", fireAsync, false);
            $window.removeEventListener("hashchange", resolveRoute, false);
        },
        view: function() {
            if (!state || $aae70388e69e8325$var$sentinel === currentResolver) return;
            // Wrap in a fragment to preserve existing key semantics
            var vnode = [
                $dBs8J(component, attrs.key, attrs)
            ];
            if (currentResolver) vnode = currentResolver.render(vnode[0]);
            return vnode;
        }
    };
    var SKIP = route.SKIP = {};
    function resolveRoute() {
        scheduled = false;
        // Consider the pathname holistically. The prefix might even be invalid,
        // but that's not our problem.
        var prefix = $window.location.hash;
        if (route.prefix[0] !== "#") {
            prefix = $window.location.search + prefix;
            if (route.prefix[0] !== "?") {
                prefix = $window.location.pathname + prefix;
                if (prefix[0] !== "/") prefix = "/" + prefix;
            }
        }
        // This seemingly useless `.concat()` speeds up the tests quite a bit,
        // since the representation is consistently a relatively poorly
        // optimized cons string.
        var path = prefix.concat().replace(/(?:%[a-f89][a-f0-9])+/gim, $aae70388e69e8325$var$decodeURIComponentSave).slice(route.prefix.length);
        var data = $7lWrV(path);
        Object.assign(data.params, $window.history.state);
        function reject(e) {
            console.error(e);
            setPath(fallbackRoute, null, {
                replace: true
            });
        }
        loop(0);
        function loop(i) {
            // state === 0: init
            // state === 1: scheduled
            // state === 2: done
            for(; i < compiled.length; i++)if (compiled[i].check(data)) {
                var payload = compiled[i].component;
                var matchedRoute = compiled[i].route;
                var localComp = payload;
                var update = lastUpdate = function(comp) {
                    if (update !== lastUpdate) return;
                    if (comp === SKIP) return loop(i + 1);
                    component = comp != null && (typeof comp.view === "function" || typeof comp === "function") ? comp : "div";
                    attrs = data.params, currentPath = path, lastUpdate = null;
                    currentResolver = payload.render ? payload : null;
                    if (state === 2) mountRedraw.redraw();
                    else {
                        state = 2;
                        mountRedraw.redraw.sync();
                    }
                };
                // There's no understating how much I *wish* I could
                // use `async`/`await` here...
                if (payload.view || typeof payload === "function") {
                    payload = {};
                    update(localComp);
                } else if (payload.onmatch) p.then(function() {
                    return payload.onmatch(data.params, path, matchedRoute);
                }).then(update, path === fallbackRoute ? null : reject);
                else update("div");
                return;
            }
            if (path === fallbackRoute) throw new Error("Could not resolve default route " + fallbackRoute + ".");
            setPath(fallbackRoute, null, {
                replace: true
            });
        }
    }
    // Set it unconditionally so `m.route.set` and `m.route.Link` both work,
    // even if neither `pushState` nor `hashchange` are supported. It's
    // cleared if `hashchange` is used, since that makes it automatically
    // async.
    function fireAsync() {
        if (!scheduled) {
            scheduled = true;
            // TODO: just do `mountRedraw.redraw()` here and elide the timer
            // dependency. Note that this will muck with tests a *lot*, so it's
            // not as easy of a change as it sounds.
            callAsync(resolveRoute);
        }
    }
    function setPath(path, data, options) {
        path = $cITMw(path, data);
        if (ready) {
            fireAsync();
            var state = options ? options.state : null;
            var title = options ? options.title : null;
            if (options && options.replace) $window.history.replaceState(state, title, route.prefix + path);
            else $window.history.pushState(state, title, route.prefix + path);
        } else $window.location.href = route.prefix + path;
    }
    function route(root, defaultRoute, routes) {
        if (!root) throw new TypeError("DOM element being rendered to does not exist.");
        compiled = Object.keys(routes).map(function(route) {
            if (route[0] !== "/") throw new SyntaxError("Routes must start with a '/'.");
            if (/:([^\/\.-]+)(\.{3})?:/.test(route)) throw new SyntaxError("Route parameter names must be separated with either '/', '.', or '-'.");
            return {
                route: route,
                component: routes[route],
                check: $8KlxE(route)
            };
        });
        fallbackRoute = defaultRoute;
        if (defaultRoute != null) {
            var defaultData = $7lWrV(defaultRoute);
            if (!compiled.some(function(i) {
                return i.check(defaultData);
            })) throw new ReferenceError("Default route doesn't match any known routes.");
        }
        if (typeof $window.history.pushState === "function") $window.addEventListener("popstate", fireAsync, false);
        else if (route.prefix[0] === "#") $window.addEventListener("hashchange", resolveRoute, false);
        ready = true;
        mountRedraw.mount(root, RouterRoot);
        resolveRoute();
    }
    route.set = function(path, data, options) {
        if (lastUpdate != null) {
            options = options || {};
            options.replace = true;
        }
        lastUpdate = null;
        setPath(path, data, options);
    };
    route.get = function() {
        return currentPath;
    };
    route.prefix = "#!";
    route.Link = {
        view: function(vnode) {
            // Omit the used parameters from the rendered element - they are
            // internal. Also, censor the various lifecycle methods.
            //
            // We don't strip the other parameters because for convenience we
            // let them be specified in the selector as well.
            var child = $iVcuU(vnode.attrs.selector || "a", $e9o88(vnode.attrs, [
                "options",
                "params",
                "selector",
                "onclick"
            ]), vnode.children);
            var options, onclick, href;
            // Let's provide a *right* way to disable a route link, rather than
            // letting people screw up accessibility on accident.
            //
            // The attribute is coerced so users don't get surprised over
            // `disabled: 0` resulting in a button that's somehow routable
            // despite being visibly disabled.
            if (child.attrs.disabled = Boolean(child.attrs.disabled)) {
                child.attrs.href = null;
                child.attrs["aria-disabled"] = "true";
            // If you *really* do want add `onclick` on a disabled link, use
            // an `oncreate` hook to add it.
            } else {
                options = vnode.attrs.options;
                onclick = vnode.attrs.onclick;
                // Easier to build it now to keep it isomorphic.
                href = $cITMw(child.attrs.href, vnode.attrs.params);
                child.attrs.href = route.prefix + href;
                child.attrs.onclick = function(e) {
                    var result;
                    if (typeof onclick === "function") result = onclick.call(e.currentTarget, e);
                    else if (onclick == null || typeof onclick !== "object") ;
                    else if (typeof onclick.handleEvent === "function") onclick.handleEvent(e);
                    // Adapted from React Router's implementation:
                    // https://github.com/ReactTraining/react-router/blob/520a0acd48ae1b066eb0b07d6d4d1790a1d02482/packages/react-router-dom/modules/Link.js
                    //
                    // Try to be flexible and intuitive in how we handle links.
                    // Fun fact: links aren't as obvious to get right as you
                    // would expect. There's a lot more valid ways to click a
                    // link than this, and one might want to not simply click a
                    // link, but right click or command-click it to copy the
                    // link target, etc. Nope, this isn't just for blind people.
                    if (// Skip if `onclick` prevented default
                    result !== false && !e.defaultPrevented && // Ignore everything but left clicks
                    (e.button === 0 || e.which === 0 || e.which === 1) && // Let the browser handle `target=_blank`, etc.
                    (!e.currentTarget.target || e.currentTarget.target === "_self") && // No modifier keys
                    !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey) {
                        e.preventDefault();
                        e.redraw = false;
                        route.set(href, null, options);
                    }
                };
            }
            return child;
        }
    };
    route.param = function(key) {
        return attrs && key != null ? attrs[key] : attrs;
    };
    return route;
};

});
parcelRegister("iVcuU", function(module, exports) {
"use strict";

var $dBs8J = parcelRequire("dBs8J");

var $5sRXF = parcelRequire("5sRXF");

var $9eOch = parcelRequire("9eOch");
var $dc673ea23ab51a3f$var$selectorParser = /(?:(^|#|\.)([^#\.\[\]]+))|(\[(.+?)(?:\s*=\s*("|'|)((?:\\["'\]]|.)*?)\5)?\])/g;
var $dc673ea23ab51a3f$var$selectorCache = Object.create(null);
function $dc673ea23ab51a3f$var$isEmpty(object) {
    for(var key in object)if ($9eOch.call(object, key)) return false;
    return true;
}
function $dc673ea23ab51a3f$var$compileSelector(selector) {
    var match, tag = "div", classes = [], attrs = {};
    while(match = $dc673ea23ab51a3f$var$selectorParser.exec(selector)){
        var type = match[1], value = match[2];
        if (type === "" && value !== "") tag = value;
        else if (type === "#") attrs.id = value;
        else if (type === ".") classes.push(value);
        else if (match[3][0] === "[") {
            var attrValue = match[6];
            if (attrValue) attrValue = attrValue.replace(/\\(["'])/g, "$1").replace(/\\\\/g, "\\");
            if (match[4] === "class") classes.push(attrValue);
            else attrs[match[4]] = attrValue === "" ? attrValue : attrValue || true;
        }
    }
    if (classes.length > 0) attrs.className = classes.join(" ");
    if ($dc673ea23ab51a3f$var$isEmpty(attrs)) attrs = null;
    return $dc673ea23ab51a3f$var$selectorCache[selector] = {
        tag: tag,
        attrs: attrs
    };
}
function $dc673ea23ab51a3f$var$execSelector(state, vnode) {
    var attrs = vnode.attrs;
    var hasClass = $9eOch.call(attrs, "class");
    var className = hasClass ? attrs.class : attrs.className;
    vnode.tag = state.tag;
    if (state.attrs != null) {
        attrs = Object.assign({}, state.attrs, attrs);
        if (className != null || state.attrs.className != null) attrs.className = className != null ? state.attrs.className != null ? String(state.attrs.className) + " " + String(className) : className : state.attrs.className != null ? state.attrs.className : null;
    } else if (className != null) attrs.className = className;
    if (hasClass) attrs.class = null;
    // workaround for #2622 (reorder keys in attrs to set "type" first)
    // The DOM does things to inputs based on the "type", so it needs set first.
    // See: https://github.com/MithrilJS/mithril.js/issues/2622
    if (state.tag === "input" && $9eOch.call(attrs, "type")) attrs = Object.assign({
        type: attrs.type
    }, attrs);
    vnode.attrs = attrs;
    return vnode;
}
function $dc673ea23ab51a3f$var$hyperscript(selector) {
    if (selector == null || typeof selector !== "string" && typeof selector !== "function" && typeof selector.view !== "function") throw Error("The selector must be either a string or a component.");
    var vnode = $5sRXF.apply(1, arguments);
    if (typeof selector === "string") {
        vnode.children = $dBs8J.normalizeChildren(vnode.children);
        if (selector !== "[") return $dc673ea23ab51a3f$var$execSelector($dc673ea23ab51a3f$var$selectorCache[selector] || $dc673ea23ab51a3f$var$compileSelector(selector), vnode);
    }
    vnode.tag = selector;
    return vnode;
}
module.exports = $dc673ea23ab51a3f$var$hyperscript;

});

parcelRegister("7lWrV", function(module, exports) {
"use strict";

var $gZZfO = parcelRequire("gZZfO");
// Returns `{path, params}` from `url`
module.exports = function(url) {
    var queryIndex = url.indexOf("?");
    var hashIndex = url.indexOf("#");
    var queryEnd = hashIndex < 0 ? url.length : hashIndex;
    var pathEnd = queryIndex < 0 ? queryEnd : queryIndex;
    var path = url.slice(0, pathEnd).replace(/\/{2,}/g, "/");
    if (!path) path = "/";
    else if (path[0] !== "/") path = "/" + path;
    return {
        path: path,
        params: queryIndex < 0 ? {} : $gZZfO(url.slice(queryIndex + 1, queryEnd))
    };
};

});
parcelRegister("gZZfO", function(module, exports) {
"use strict";
function $c601dba597649f5e$var$decodeURIComponentSave(str) {
    try {
        return decodeURIComponent(str);
    } catch (err) {
        return str;
    }
}
module.exports = function(string) {
    if (string === "" || string == null) return {};
    if (string.charAt(0) === "?") string = string.slice(1);
    var entries = string.split("&"), counters = {}, data = {};
    for(var i = 0; i < entries.length; i++){
        var entry = entries[i].split("=");
        var key = $c601dba597649f5e$var$decodeURIComponentSave(entry[0]);
        var value = entry.length === 2 ? $c601dba597649f5e$var$decodeURIComponentSave(entry[1]) : "";
        if (value === "true") value = true;
        else if (value === "false") value = false;
        var levels = key.split(/\]\[?|\[/);
        var cursor = data;
        if (key.indexOf("[") > -1) levels.pop();
        for(var j = 0; j < levels.length; j++){
            var level = levels[j], nextLevel = levels[j + 1];
            var isNumber = nextLevel == "" || !isNaN(parseInt(nextLevel, 10));
            if (level === "") {
                var key = levels.slice(0, j).join();
                if (counters[key] == null) counters[key] = Array.isArray(cursor) ? cursor.length : 0;
                level = counters[key]++;
            } else if (level === "__proto__") break;
            if (j === levels.length - 1) cursor[level] = value;
            else {
                // Read own properties exclusively to disallow indirect
                // prototype pollution
                var desc = Object.getOwnPropertyDescriptor(cursor, level);
                if (desc != null) desc = desc.value;
                if (desc == null) cursor[level] = desc = isNumber ? [] : {};
                cursor = desc;
            }
        }
    }
    return data;
};

});


parcelRegister("8KlxE", function(module, exports) {
"use strict";

var $7lWrV = parcelRequire("7lWrV");
// Compiles a template into a function that takes a resolved path (without query
// strings) and returns an object containing the template parameters with their
// parsed values. This expects the input of the compiled template to be the
// output of `parsePathname`. Note that it does *not* remove query parameters
// specified in the template.
module.exports = function(template) {
    var templateData = $7lWrV(template);
    var templateKeys = Object.keys(templateData.params);
    var keys = [];
    var regexp = new RegExp("^" + templateData.path.replace(// I escape literal text so people can use things like `:file.:ext` or
    // `:lang-:locale` in routes. This is all merged into one pass so I
    // don't also accidentally escape `-` and make it harder to detect it to
    // ban it from template parameters.
    /:([^\/.-]+)(\.{3}|\.(?!\.)|-)?|[\\^$*+.()|\[\]{}]/g, function(m, key, extra) {
        if (key == null) return "\\" + m;
        keys.push({
            k: key,
            r: extra === "..."
        });
        if (extra === "...") return "(.*)";
        if (extra === ".") return "([^/]+)\\.";
        return "([^/]+)" + (extra || "");
    }) + "$");
    return function(data) {
        // First, check the params. Usually, there isn't any, and it's just
        // checking a static set.
        for(var i = 0; i < templateKeys.length; i++){
            if (templateData.params[templateKeys[i]] !== data.params[templateKeys[i]]) return false;
        }
        // If no interpolations exist, let's skip all the ceremony
        if (!keys.length) return regexp.test(data.path);
        var values = regexp.exec(data.path);
        if (values == null) return false;
        for(var i = 0; i < keys.length; i++)data.params[keys[i].k] = keys[i].r ? values[i + 1] : decodeURIComponent(values[i + 1]);
        return true;
    };
};

});

parcelRegister("e9o88", function(module, exports) {
"use strict";

var $9eOch = parcelRequire("9eOch");
// Words in RegExp literals are sometimes mangled incorrectly by the internal bundler, so use RegExp().
var $a4d49fb46380177c$var$magic = new RegExp("^(?:key|oninit|oncreate|onbeforeupdate|onupdate|onbeforeremove|onremove)$");
module.exports = function(attrs, extras) {
    var result = {};
    if (extras != null) {
        for(var key in attrs)if ($9eOch.call(attrs, key) && !$a4d49fb46380177c$var$magic.test(key) && extras.indexOf(key) < 0) result[key] = attrs[key];
    } else {
        for(var key in attrs)if ($9eOch.call(attrs, key) && !$a4d49fb46380177c$var$magic.test(key)) result[key] = attrs[key];
    }
    return result;
};

});



parcelRegister("5J9XC", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
var $42b8e1aee0ef989d$var$isValidString = function isValidString(param) {
    return typeof param === 'string' && param.length > 0;
};
var $42b8e1aee0ef989d$var$startsWith = function startsWith(string, start) {
    return string[0] === start;
};
var $42b8e1aee0ef989d$var$isSelector = function isSelector(param) {
    return $42b8e1aee0ef989d$var$isValidString(param) && ($42b8e1aee0ef989d$var$startsWith(param, '.') || $42b8e1aee0ef989d$var$startsWith(param, '#'));
};
var $42b8e1aee0ef989d$var$node = function node(h) {
    return function(tagName) {
        return function(first) {
            for(var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
            if ($42b8e1aee0ef989d$var$isSelector(first)) return h.apply(undefined, [
                tagName + first
            ].concat(rest));
            else if (typeof first === 'undefined') return h(tagName);
            else return h.apply(undefined, [
                tagName,
                first
            ].concat(rest));
        };
    };
};
var $42b8e1aee0ef989d$var$TAG_NAMES = [
    'a',
    'abbr',
    'acronym',
    'address',
    'applet',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'basefont',
    'bdi',
    'bdo',
    'bgsound',
    'big',
    'blink',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'command',
    'content',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'element',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'font',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'image',
    'img',
    'input',
    'ins',
    'isindex',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'listing',
    'main',
    'map',
    'mark',
    'marquee',
    'math',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'multicol',
    'nav',
    'nextid',
    'nobr',
    'noembed',
    'noframes',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'plaintext',
    'pre',
    'progress',
    'q',
    'rb',
    'rbc',
    'rp',
    'rt',
    'rtc',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'shadow',
    'slot',
    'small',
    'source',
    'spacer',
    'span',
    'strike',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'svg',
    'table',
    'tbody',
    'td',
    'template',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'tt',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'xmp'
];
module.exports['default'] = function(h) {
    var createTag = $42b8e1aee0ef989d$var$node(h);
    var exported = {
        TAG_NAMES: $42b8e1aee0ef989d$var$TAG_NAMES,
        isSelector: $42b8e1aee0ef989d$var$isSelector,
        createTag: createTag
    };
    $42b8e1aee0ef989d$var$TAG_NAMES.forEach(function(n) {
        exported[n] = createTag(n);
    });
    return exported;
};
module.exports = module.exports['default'];

});

parcelRegister("aToVp", function(module, exports) {
module.exports = new URL("profilepicture.9aa87836.jpeg", import.meta.url).toString();

});

parcelRegister("68ADa", function(module, exports) {
module.exports = new URL("strassburg.d83f02bb.webp", import.meta.url).toString();

});

parcelRegister("kKJJu", function(module, exports) {
module.exports = new URL("schillerplatz.2d746c54.jpeg", import.meta.url).toString();

});

parcelRegister("cdw0Z", function(module, exports) {
module.exports = new URL("starfleet.b320439b.png", import.meta.url).toString();

});

parcelRegister("6BpfQ", function(module, exports) {
module.exports = new URL("ADFC.5827f0be.png", import.meta.url).toString();

});

parcelRegister("akn7v", function(module, exports) {
module.exports = new URL("DPG.f2a21246.png", import.meta.url).toString();

});

parcelRegister("hmIor", function(module, exports) {
module.exports = new URL("FS.674b3966.jpg", import.meta.url).toString();

});

parcelRegister("dA9iQ", function(module, exports) {
module.exports = new URL("FDP.d1d6dc12.png", import.meta.url).toString();

});

parcelRegister("bM8u0", function(module, exports) {
module.exports = new URL("JuLis.b3b244da.png", import.meta.url).toString();

});

parcelRegister("4dAQU", function(module, exports) {
module.exports = new URL("LiSl.56ae123e.png", import.meta.url).toString();

});

parcelRegister("7qZKr", function(module, exports) {
module.exports = new URL("YIMBY.56a157ba.svg", import.meta.url).toString();

});

var $1e1bd8282fcb8c9d$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"aT88m\",\"index.4f14397a.js\",\"2Nf8y\",\"profilepicture.9aa87836.jpeg\",\"3oqT8\",\"strassburg.d83f02bb.webp\",\"fIVwJ\",\"schillerplatz.2d746c54.jpeg\",\"izxJ3\",\"starfleet.b320439b.png\",\"lx3ok\",\"ADFC.5827f0be.png\",\"bjHnn\",\"DPG.f2a21246.png\",\"gVqub\",\"FS.674b3966.jpg\",\"93uij\",\"FDP.d1d6dc12.png\",\"5WhLe\",\"JuLis.b3b244da.png\",\"3sOQ8\",\"LiSl.56ae123e.png\",\"lE4Ww\",\"YIMBY.56a157ba.svg\",\"5h9CN\",\"index.f90ad61f.css\"]"));

var $65d5daca13f5010c$exports = {};
"use strict";
var $20d57ad7857b7d5d$exports = {};
"use strict";

var $iVcuU = parcelRequire("iVcuU");

$iVcuU.trust = (parcelRequire("e2F9W"));

$iVcuU.fragment = (parcelRequire("7PZrX"));
$20d57ad7857b7d5d$exports = $iVcuU;


var $8fa9e1679f027da0$exports = {};
"use strict";

var $7EF0O = parcelRequire("7EF0O");

$8fa9e1679f027da0$exports = (parcelRequire("5y2KI"))(typeof window !== "undefined" ? window : null, $7EF0O.redraw);



var $7EF0O = parcelRequire("7EF0O");

var $7srYg = parcelRequire("7srYg");
var $65d5daca13f5010c$var$m = function m() {
    return $20d57ad7857b7d5d$exports.apply(this, arguments);
};
$65d5daca13f5010c$var$m.m = $20d57ad7857b7d5d$exports;
$65d5daca13f5010c$var$m.trust = $20d57ad7857b7d5d$exports.trust;
$65d5daca13f5010c$var$m.fragment = $20d57ad7857b7d5d$exports.fragment;
$65d5daca13f5010c$var$m.Fragment = "[";
$65d5daca13f5010c$var$m.mount = $7EF0O.mount;

$65d5daca13f5010c$var$m.route = (parcelRequire("4Ppi2"));

$65d5daca13f5010c$var$m.render = (parcelRequire("j25vk"));
$65d5daca13f5010c$var$m.redraw = $7EF0O.redraw;
$65d5daca13f5010c$var$m.request = $8fa9e1679f027da0$exports.request;

$65d5daca13f5010c$var$m.parseQueryString = (parcelRequire("gZZfO"));

$65d5daca13f5010c$var$m.buildQueryString = (parcelRequire("iRA82"));

$65d5daca13f5010c$var$m.parsePathname = (parcelRequire("7lWrV"));

$65d5daca13f5010c$var$m.buildPathname = (parcelRequire("cITMw"));

$65d5daca13f5010c$var$m.vnode = (parcelRequire("dBs8J"));

$65d5daca13f5010c$var$m.censor = (parcelRequire("e9o88"));
$65d5daca13f5010c$var$m.domFor = $7srYg.domFor;
$65d5daca13f5010c$exports = $65d5daca13f5010c$var$m;




var $932153c46d04a6c0$exports = {};

$parcel$export($932153c46d04a6c0$exports, "base", () => $932153c46d04a6c0$export$e2253033e6e1df16, (v) => $932153c46d04a6c0$export$e2253033e6e1df16 = v);
var $932153c46d04a6c0$export$e2253033e6e1df16;
$932153c46d04a6c0$export$e2253033e6e1df16 = `OwryxG_base`;



const { div: $91af4f15a96bbf73$var$div } = (parcelRequire("5J9XC"))($65d5daca13f5010c$exports);
class $91af4f15a96bbf73$export$ef88aa0d34c34520 {
    constructor(attrs, component){
        this.attrs = attrs;
        this.component = component;
    }
}
const $91af4f15a96bbf73$var$BaseTemplate = {
    async oninit (vnode) {
        document.title = "Filipe Ramalho - " + vnode.attrs.name;
    },
    view (vnode) {
        return $91af4f15a96bbf73$var$div({
            class: (0, (/*@__PURE__*/$parcel$interopDefault($932153c46d04a6c0$exports))).base
        }, vnode.children);
    }
};
var $91af4f15a96bbf73$export$2e2bcd8739ae039 = $91af4f15a96bbf73$var$BaseTemplate;


var $ad287d520f104e45$exports = {};

$parcel$export($ad287d520f104e45$exports, "aboutme", () => $ad287d520f104e45$export$f1697ec4f92e63a3, (v) => $ad287d520f104e45$export$f1697ec4f92e63a3 = v);
$parcel$export($ad287d520f104e45$exports, "block", () => $ad287d520f104e45$export$837bd02682cd3db9, (v) => $ad287d520f104e45$export$837bd02682cd3db9 = v);
$parcel$export($ad287d520f104e45$exports, "blocks", () => $ad287d520f104e45$export$12a40731da9c9684, (v) => $ad287d520f104e45$export$12a40731da9c9684 = v);
$parcel$export($ad287d520f104e45$exports, "buttons", () => $ad287d520f104e45$export$bbea856fdb3e3c5f, (v) => $ad287d520f104e45$export$bbea856fdb3e3c5f = v);
$parcel$export($ad287d520f104e45$exports, "img", () => $ad287d520f104e45$export$463b44d9bf3628be, (v) => $ad287d520f104e45$export$463b44d9bf3628be = v);
$parcel$export($ad287d520f104e45$exports, "intro", () => $ad287d520f104e45$export$affaf52642033041, (v) => $ad287d520f104e45$export$affaf52642033041 = v);
$parcel$export($ad287d520f104e45$exports, "quote", () => $ad287d520f104e45$export$ee7a15c61bfdeb11, (v) => $ad287d520f104e45$export$ee7a15c61bfdeb11 = v);
$parcel$export($ad287d520f104e45$exports, "quotebox", () => $ad287d520f104e45$export$27e7ffd1da5321d5, (v) => $ad287d520f104e45$export$27e7ffd1da5321d5 = v);
$parcel$export($ad287d520f104e45$exports, "splashblock", () => $ad287d520f104e45$export$9560c6cacaca6ea3, (v) => $ad287d520f104e45$export$9560c6cacaca6ea3 = v);
var $ad287d520f104e45$export$f1697ec4f92e63a3;
var $ad287d520f104e45$export$837bd02682cd3db9;
var $ad287d520f104e45$export$12a40731da9c9684;
var $ad287d520f104e45$export$bbea856fdb3e3c5f;
var $ad287d520f104e45$export$463b44d9bf3628be;
var $ad287d520f104e45$export$affaf52642033041;
var $ad287d520f104e45$export$ee7a15c61bfdeb11;
var $ad287d520f104e45$export$27e7ffd1da5321d5;
var $ad287d520f104e45$export$9560c6cacaca6ea3;
$ad287d520f104e45$export$f1697ec4f92e63a3 = `N31LnG_aboutme`;
$ad287d520f104e45$export$837bd02682cd3db9 = `N31LnG_block`;
$ad287d520f104e45$export$12a40731da9c9684 = `N31LnG_blocks`;
$ad287d520f104e45$export$bbea856fdb3e3c5f = `N31LnG_buttons`;
$ad287d520f104e45$export$463b44d9bf3628be = `N31LnG_img`;
$ad287d520f104e45$export$affaf52642033041 = `N31LnG_intro`;
$ad287d520f104e45$export$ee7a15c61bfdeb11 = `N31LnG_quote`;
$ad287d520f104e45$export$27e7ffd1da5321d5 = `N31LnG_quotebox`;
$ad287d520f104e45$export$9560c6cacaca6ea3 = `N31LnG_splashblock`;



var $61dbd166f871591d$exports = {};

$parcel$export($61dbd166f871591d$exports, "button", () => $61dbd166f871591d$export$2ba01fb71ed41cb6, (v) => $61dbd166f871591d$export$2ba01fb71ed41cb6 = v);
$parcel$export($61dbd166f871591d$exports, "threads", () => $61dbd166f871591d$export$8a4dea38c4da78cf, (v) => $61dbd166f871591d$export$8a4dea38c4da78cf = v);
var $61dbd166f871591d$export$2ba01fb71ed41cb6;
var $61dbd166f871591d$export$8a4dea38c4da78cf;
$61dbd166f871591d$export$2ba01fb71ed41cb6 = `qqGjCa_button`;
$61dbd166f871591d$export$8a4dea38c4da78cf = `qqGjCa_threads`;



const { a: $73752fc4dd78441c$var$a } = (parcelRequire("5J9XC"))($65d5daca13f5010c$exports);
const $73752fc4dd78441c$export$353f5b6fc5456de1 = {
    view: function(vnode) {
        if (vnode.attrs.newTab) return $73752fc4dd78441c$var$a({
            href: vnode.attrs.href,
            class: (0, (/*@__PURE__*/$parcel$interopDefault($61dbd166f871591d$exports))).button,
            target: "_blank",
            rel: " noopener noreferrer",
            style: "background-color:" + vnode.attrs.color + ";" + "color:" + vnode.attrs.textColor
        }, vnode.attrs.name);
        else return $73752fc4dd78441c$var$a({
            href: vnode.attrs.href,
            class: (0, (/*@__PURE__*/$parcel$interopDefault($61dbd166f871591d$exports))).button,
            style: "background-color:" + vnode.attrs.color + ";" + "color:" + vnode.attrs.textColor
        }, vnode.attrs.name);
    }
};



const { div: $64a3c3778c7bd579$var$div, h1: $64a3c3778c7bd579$var$h1, h2: $64a3c3778c7bd579$var$h2, br: $64a3c3778c7bd579$var$br, img: $64a3c3778c7bd579$var$img } = (parcelRequire("5J9XC"))($65d5daca13f5010c$exports);




const $64a3c3778c7bd579$var$HomePage = new (0, $91af4f15a96bbf73$export$ef88aa0d34c34520)({
    name: "Home",
    id: "home",
    route: "/"
}, {
    view () {
        return $65d5daca13f5010c$exports((0, $91af4f15a96bbf73$export$2e2bcd8739ae039), $64a3c3778c7bd579$var$HomePage.attrs, [
            $64a3c3778c7bd579$var$div({
                class: (0, (/*@__PURE__*/$parcel$interopDefault($ad287d520f104e45$exports))).blocks
            }, [
                $64a3c3778c7bd579$var$div({
                    class: (0, (/*@__PURE__*/$parcel$interopDefault($ad287d520f104e45$exports))).splashblock
                }, [
                    $64a3c3778c7bd579$var$div({
                        class: (0, (/*@__PURE__*/$parcel$interopDefault($ad287d520f104e45$exports))).intro
                    }, [
                        $64a3c3778c7bd579$var$h1("Filipe", $64a3c3778c7bd579$var$br(), "Ramalho"),
                        "Physiker. ITler. Liberal. YIMBY.",
                        $64a3c3778c7bd579$var$div({
                            class: (0, (/*@__PURE__*/$parcel$interopDefault($ad287d520f104e45$exports))).buttons
                        }, [
                            $65d5daca13f5010c$exports((0, $73752fc4dd78441c$export$353f5b6fc5456de1), {
                                newTab: true,
                                href: "https://threads.net/@filipe.mdsr",
                                color: "black",
                                textColor: "white",
                                name: "Threads"
                            }),
                            $65d5daca13f5010c$exports((0, $73752fc4dd78441c$export$353f5b6fc5456de1), {
                                newTab: true,
                                href: "https://github.com/FilipeRamalho",
                                color: "black",
                                textColor: "white",
                                name: "Github"
                            }),
                            $65d5daca13f5010c$exports((0, $73752fc4dd78441c$export$353f5b6fc5456de1), {
                                newTab: true,
                                href: "https://www.linkedin.com/in/fmdsr/",
                                color: "black",
                                textColor: "white",
                                name: "LinkedIn"
                            }),
                            $65d5daca13f5010c$exports((0, $73752fc4dd78441c$export$353f5b6fc5456de1), {
                                newTab: true,
                                href: "https://www.instagram.com/filipe.mdsr/",
                                color: "black",
                                textColor: "white",
                                name: "Instagram"
                            }),
                            $65d5daca13f5010c$exports((0, $73752fc4dd78441c$export$353f5b6fc5456de1), {
                                newTab: true,
                                href: "https://yimby.jetzt/author/filipe/",
                                color: "black",
                                textColor: "white",
                                name: "YIMBY DE"
                            })
                        ])
                    ]),
                    $64a3c3778c7bd579$var$div({
                        class: (0, (/*@__PURE__*/$parcel$interopDefault($ad287d520f104e45$exports))).img
                    }, [
                        $64a3c3778c7bd579$var$img({
                            src: (parcelRequire("aToVp"))
                        })
                    ])
                ]),
                /*div({class: style.block, style: "background-color: #A81900; color: white;"},[
                        h1("Meine Beiträge")
                    ]),*/ $64a3c3778c7bd579$var$img({
                    src: (parcelRequire("68ADa"))
                }),
                $64a3c3778c7bd579$var$div({
                    class: (0, (/*@__PURE__*/$parcel$interopDefault($ad287d520f104e45$exports))).block + " " + (0, (/*@__PURE__*/$parcel$interopDefault($ad287d520f104e45$exports))).aboutme,
                    style: "background-color: #5B9400; color: white;"
                }, [
                    $64a3c3778c7bd579$var$h1("\xdcber Mich"),
                    $64a3c3778c7bd579$var$br(),
                    "Ol\xe1! Mein Name ist Filipe und ich studiere Physik. Nebenbei arbeite ich als Werkstudent im IT-Monitoring bei der Berufsgenossenschaft Holz und Metall.",
                    " Geboren bin ich in Coimbra. W\xe4hrend der Wirtschaftskrise 2009 ist meine Familie nach Rheinhessen gezogen. So hatte ich eine rhoihessisch-portugiesische Kindheit. Dementsprechend trinke ich gerne Wein aus den zwei besten Weinanbaugebieten der Welt.",
                    $64a3c3778c7bd579$var$br(),
                    "Ich fahre leidenschaftlich gerne Fahrrad, sowohl sportlich als auch im Alltag. Au\xdferdem bin ich ein gro\xdfer Fan von lebendigen, gr\xfcnen, dichten und modernen St\xe4dten.",
                    " Nach einem langen Tag entspanne ich am liebsten mit einer Folge Star Trek oder Doctor Who. Diese Serien sind mehr als nur Unterhaltung f\xfcr mich - sie zeigen eine Zukunft, wie ich sie mir w\xfcnsche: Eine Welt mit mehr Freiheit und Demokratie f\xfcr alle Menschen.",
                    $64a3c3778c7bd579$var$div({
                        class: (0, (/*@__PURE__*/$parcel$interopDefault($ad287d520f104e45$exports))).buttons
                    }, [
                        /*m(Button, {
                                newTab: false,
                                href: "/lebenslauf",
                                color: "black",
                                textColor: "white",
                                name: "Lebenslauf"
                            }),*/ $65d5daca13f5010c$exports((0, $73752fc4dd78441c$export$353f5b6fc5456de1), {
                            newTab: false,
                            href: "/mitgliedschaften",
                            color: "black",
                            textColor: "white",
                            name: "Mitgliedschaften"
                        })
                    ])
                ]),
                /*img({src: require("/assets/img/oszi.jpeg")}),
                    div({class: style.block, style: "background-color: #4B009B; color: white;"},[
                        h1("Meine Projekte")
                    ]),*/ $64a3c3778c7bd579$var$img({
                    src: (parcelRequire("kKJJu"))
                }),
                $64a3c3778c7bd579$var$div({
                    class: (0, (/*@__PURE__*/$parcel$interopDefault($ad287d520f104e45$exports))).block + " " + (0, (/*@__PURE__*/$parcel$interopDefault($ad287d520f104e45$exports))).quotebox,
                    style: "background-color: #0D6552; color: white;"
                }, [
                    $64a3c3778c7bd579$var$img({
                        src: (parcelRequire("cdw0Z"))
                    }),
                    $64a3c3778c7bd579$var$div({
                        class: (0, (/*@__PURE__*/$parcel$interopDefault($ad287d520f104e45$exports))).quote
                    }, [
                        $64a3c3778c7bd579$var$h1("It\u2019s possible to commit no mistakes and still lose. That\u2019s not a weakness, that is life."),
                        $64a3c3778c7bd579$var$h2("-Jean-Luc Picard")
                    ])
                ])
            ])
        ]);
    }
});
var $64a3c3778c7bd579$export$2e2bcd8739ae039 = $64a3c3778c7bd579$var$HomePage;




var $e1e580677d23db6c$exports = {};

$parcel$export($e1e580677d23db6c$exports, "blocks", () => $e1e580677d23db6c$export$12a40731da9c9684, (v) => $e1e580677d23db6c$export$12a40731da9c9684 = v);
$parcel$export($e1e580677d23db6c$exports, "buttons", () => $e1e580677d23db6c$export$bbea856fdb3e3c5f, (v) => $e1e580677d23db6c$export$bbea856fdb3e3c5f = v);
$parcel$export($e1e580677d23db6c$exports, "splashblock", () => $e1e580677d23db6c$export$9560c6cacaca6ea3, (v) => $e1e580677d23db6c$export$9560c6cacaca6ea3 = v);
var $e1e580677d23db6c$export$12a40731da9c9684;
var $e1e580677d23db6c$export$bbea856fdb3e3c5f;
var $e1e580677d23db6c$export$9560c6cacaca6ea3;
$e1e580677d23db6c$export$12a40731da9c9684 = `lNYPja_blocks`;
$e1e580677d23db6c$export$bbea856fdb3e3c5f = `lNYPja_buttons`;
$e1e580677d23db6c$export$9560c6cacaca6ea3 = `lNYPja_splashblock`;




const { div: $4b99905b800c881b$var$div, h1: $4b99905b800c881b$var$h1, a: $4b99905b800c881b$var$a, img: $4b99905b800c881b$var$img } = (parcelRequire("5J9XC"))($65d5daca13f5010c$exports);







const $4b99905b800c881b$var$HomePage = new (0, $91af4f15a96bbf73$export$ef88aa0d34c34520)({
    name: "Mitgliedschaften",
    id: "memberships",
    route: "/mitgliedschaften"
}, {
    view () {
        return $65d5daca13f5010c$exports((0, $91af4f15a96bbf73$export$2e2bcd8739ae039), $4b99905b800c881b$var$HomePage.attrs, [
            $4b99905b800c881b$var$div({
                class: (0, (/*@__PURE__*/$parcel$interopDefault($e1e580677d23db6c$exports))).blocks
            }, [
                $4b99905b800c881b$var$div({
                    class: (0, (/*@__PURE__*/$parcel$interopDefault($e1e580677d23db6c$exports))).splashblock
                }, [
                    $65d5daca13f5010c$exports((0, $73752fc4dd78441c$export$353f5b6fc5456de1), {
                        newTab: false,
                        href: "/",
                        color: "black",
                        textColor: "white",
                        name: "Startseite"
                    }),
                    $4b99905b800c881b$var$h1("Mitgliedschaften"),
                    $4b99905b800c881b$var$a({
                        href: "https://adfc.de",
                        target: "_blank",
                        rel: " noopener noreferrer"
                    }, $4b99905b800c881b$var$img({
                        src: (parcelRequire("6BpfQ")),
                        alt: "Allgemeiner Deutscher Fahrrad-Club"
                    })),
                    $4b99905b800c881b$var$a({
                        href: "https://dpg-physik.de",
                        target: "_blank",
                        rel: " noopener noreferrer"
                    }, $4b99905b800c881b$var$img({
                        src: (parcelRequire("akn7v")),
                        alt: "Deutsche Physikalische Gesellschaft"
                    })),
                    $4b99905b800c881b$var$a({
                        href: "https://fachschaft.physik.uni-mainz.de",
                        target: "_blank",
                        rel: " noopener noreferrer"
                    }, $4b99905b800c881b$var$img({
                        src: (parcelRequire("hmIor")),
                        alt: "Fachschaft Physik Mainz"
                    })),
                    $4b99905b800c881b$var$a({
                        href: "https://fdp.de",
                        target: "_blank",
                        rel: " noopener noreferrer"
                    }, $4b99905b800c881b$var$img({
                        src: (parcelRequire("dA9iQ")),
                        alt: "Freie Demokratische Partei"
                    })),
                    $4b99905b800c881b$var$a({
                        href: "https://julis.de",
                        target: "_blank",
                        rel: " noopener noreferrer"
                    }, $4b99905b800c881b$var$img({
                        src: (parcelRequire("bM8u0")),
                        alt: "Junge Liberale"
                    })),
                    $4b99905b800c881b$var$a({
                        href: "https://lisl-deutschland.de",
                        target: "_blank",
                        rel: " noopener noreferrer"
                    }, $4b99905b800c881b$var$img({
                        src: (parcelRequire("4dAQU")),
                        alt: "Liberale Schwule, Lesben, Bi, Trans und Queer"
                    })),
                    $4b99905b800c881b$var$a({
                        href: "https://yimby.jetzt",
                        target: "_blank",
                        rel: " noopener noreferrer"
                    }, $4b99905b800c881b$var$img({
                        src: (parcelRequire("7qZKr")),
                        alt: "YIMBY Deutschland"
                    }))
                ])
            ])
        ]);
    }
});
var $4b99905b800c881b$export$2e2bcd8739ae039 = $4b99905b800c881b$var$HomePage;







const { div: $7a33464693cc0dac$var$div, h1: $7a33464693cc0dac$var$h1 } = (parcelRequire("5J9XC"))($65d5daca13f5010c$exports);
const $7a33464693cc0dac$var$HomePage = new (0, $91af4f15a96bbf73$export$ef88aa0d34c34520)({
    name: "Lebenslauf",
    id: "cv",
    route: "/lebenslauf"
}, {
    view () {
        return $65d5daca13f5010c$exports((0, $91af4f15a96bbf73$export$2e2bcd8739ae039), $7a33464693cc0dac$var$HomePage.attrs, [
            $7a33464693cc0dac$var$div({
                class: (0, (/*@__PURE__*/$parcel$interopDefault($e1e580677d23db6c$exports))).blocks
            }, [
                $7a33464693cc0dac$var$div({
                    class: (0, (/*@__PURE__*/$parcel$interopDefault($e1e580677d23db6c$exports))).splashblock
                }, [
                    $7a33464693cc0dac$var$h1("Lebenslauf"),
                    $65d5daca13f5010c$exports((0, $73752fc4dd78441c$export$353f5b6fc5456de1), {
                        newTab: false,
                        href: "/",
                        color: "black",
                        textColor: "white",
                        name: "Startseite"
                    })
                ])
            ])
        ]);
    }
});
var $7a33464693cc0dac$export$2e2bcd8739ae039 = $7a33464693cc0dac$var$HomePage;


var $66bd2f909dab14d6$export$2e2bcd8739ae039 = [
    (0, $64a3c3778c7bd579$export$2e2bcd8739ae039),
    (0, $4b99905b800c881b$export$2e2bcd8739ae039),
    (0, $7a33464693cc0dac$export$2e2bcd8739ae039)
];




$65d5daca13f5010c$exports.route.prefix = "";
// Define in which element in index.html mithril will run
const $ad2bcec7a0192558$var$el = document.getElementById("content");
// Set routing prefix
$65d5daca13f5010c$exports.route.prefix = '';
// Add routing and install modules
const $ad2bcec7a0192558$var$routes = {};
for (const page of (0, $66bd2f909dab14d6$export$2e2bcd8739ae039))$ad2bcec7a0192558$var$routes[page.attrs.route] = page.component;
// Start Mithril routing with final settings
$65d5daca13f5010c$exports.route($ad2bcec7a0192558$var$el, "/", $ad2bcec7a0192558$var$routes);


//# sourceMappingURL=index.4f14397a.js.map
